
// Helper model for using sorting and filtering
export class Filter {
    field: string;
    values: Array<string> = [];
    
    constructor(field: string, values: Array<string>){
        this.field = field;
        this.values = values;
    }
}
